export default __webpack_public_path__ + "static/10-d619fc0e5e1227911e2fbb13bb180f34.jpg";